// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__MBnQf","container":"modal_container__fFQ+R","btn-close":"modal_btn-close__ROnUD"};